export default "__VITE_ASSET__D5LsbWom__"